<template>
  <button
    class="duration-button"
    :class="{'is-active': isActive }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <span v-if="label" class="label">{{ label }}</span>
    <h3 class="duration">{{ duration }}</h3>
    <p class="price">{{ price | localize }} {{ monthly ? '/ maand' : ''}}</p>
  </button>
</template>

<script>
  export default {
    props: {
      duration: {
        type: String,
        default: ''
      },
      price: {
        type: [String, Number],
        default: ''
      },
      monthly: {
        type: Boolean,
        default: false
      },
      isActive: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import '../assets/styles/_variables.scss';
  @import '../assets/styles/_mixins.scss';

  .duration-button {
    position: relative;
    text-align: center;
    line-height: 1.5;
    background: transparent;
    color: inherit;
    border: 0;
    box-shadow: inset 0 0 0 1px var(--ec-gray-light, lighten(black, 85));
    padding: 1em;
    width: 100%;
    height: 100%;
    border-radius: var(--ec-border-radius, 3px);
    outline: none;
    cursor: pointer;
    transition: background-color .25s ease-out;

    @include screen(md) {
      padding: 3.5em 1em;
    }

    &.is-active {
      background-color: var(--ec-duration-button-active, lighten(black, 10));
      box-shadow: none;

      h3 {
        color: white;
      }

      p {
        color: #F7F8FB;
      }

    }

    .duration {
      font-size: 1.25em;
      line-height: 1.2;
      margin-bottom: 0.25em;

      @include screen(md) {
        margin-bottom: 0.75em;
      }

    }

  }

  .label {
    position: absolute;
    top: -15px;
    left: 50%;
    transform: translateX(-50%);
    font-size: .75em;
    font-weight: 700;
    background-color: var(--ec-primary-color, black);
    color: white;
    padding: 6px 10px;
    min-width: 110px;
    border-radius: 44px;
  }

  .price {
    color: var(--ec-gray, lighten(black, 35));
  }

</style>